import { Col, Row } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { useCommunityPartnerCredit, useResponsive } from 'Hooks';
import { clx } from 'Utils';
import { Card, ShimmerImage } from 'Elements';
import styles from 'partials/card/subscription-card.module.scss';
import { Credit } from './section/Credit';
import { SubscriptionPlan } from './section/SubscriptionPlan';
import { CommissionGroup } from './section/CommissionGroup';
import { CommissionLevel } from './section/CommissionLevel';
import { SkeletonViewCreditDecorationBox } from './skeleton/SkeletonViewCreditDecorationBox';

export const ViewCredit = () => {
	const defaultImage = '/assets/img/business-partner-default.png';
	const { credit_id } = useParams();
	const { isTabletAndAbove, isDesktopAndAbove } = useResponsive();
	const { data: credit, isLoading } = useCommunityPartnerCredit(
		credit_id as string
	);

	const getImageSize = () => {
		return isDesktopAndAbove ? 160 : isTabletAndAbove ? 136 : 112;
	};

	return (
		<>
			<Row className="mb-4">
				<Col>
					<Card className="h-100">
						{isLoading ? (
							<SkeletonViewCreditDecorationBox />
						) : (
							<div
								className={clx(
									styles.body,
									'd-flex flex-column flex-md-row gap-3'
								)}>
								<div className={styles.logoBox}>
									<ShimmerImage
										width={getImageSize()}
										height={getImageSize()}
										src={
											credit?.businessPartnerInfo
												?.thumbnailLogo ?? defaultImage
										}
										defaultImage={defaultImage}
										className={styles.shimmer}
										alt={
											credit?.businessPartnerInfo
												?.organizationName ?? ''
										}
									/>
								</div>
								<div className="flex-grow-1">
									<h3 className="h5 lh-sm fw-400 text-break">
										{
											credit?.businessPartnerInfo
												?.organizationName
										}
									</h3>
									<div className="mb-2">
										{credit?.businessPartnerInfo
											?.emailAddress && (
											<span>
												{
													credit?.businessPartnerInfo
														?.emailAddress
												}
											</span>
										)}
									</div>
								</div>
							</div>
						)}
					</Card>
				</Col>
			</Row>
			<Row>
				<Credit credit={credit} isLoading={isLoading} />
				<SubscriptionPlan credit={credit} isLoading={isLoading} />
			</Row>
			<Row className="mt-4">
				<CommissionGroup credit={credit} isLoading={isLoading} />
				<CommissionLevel credit={credit} isLoading={isLoading} />
			</Row>
		</>
	);
};
